import { useEffect, useRef } from 'react';

import { WizardStepName } from 'data/ppoints/constants';
import { useUpdateIntercomOnboardingStep } from 'hooks/intercom/useUpdateIntercomOnboardingStep';
import { useAppSelector } from 'redux/hooks';

import Clarity from '@microsoft/clarity';
import useSendGTMAction from 'features/google-tag-manager/hooks/useSendGTMAction';
import { SetupGuideStepDoneGtmAction } from 'features/google-tag-manager/model/actions/setup_guide_step_done.gtm-action';

const SetupGuideStepDoneActionListener = () => {
    const sendGTMAction = useSendGTMAction();
    const updateIntercomOnboardingStep = useUpdateIntercomOnboardingStep();

    const { steps, initialized, skippedStepNames } = useAppSelector((state) => state.wizard);

    const reportedStepNames = useRef<Set<WizardStepName> | null>(null);

    useEffect((): void => {
        if (!initialized || !steps) return;

        if (!reportedStepNames.current) {
            reportedStepNames.current = new Set(steps.filter(({ done }) => done).map(({ name }) => name));
            return;
        }

        const alreadyReported = reportedStepNames.current;

        steps
            .filter(({ name, done }) => done && !alreadyReported.has(name))
            .forEach(({ name }): void => {
                sendGTMAction(
                    new SetupGuideStepDoneGtmAction({
                        name,
                        skipped: skippedStepNames.includes(name),
                    })
                );

                try {
                    Clarity.event('SetupGuideStepDone');
                } catch (error) {}

                updateIntercomOnboardingStep(name);
                alreadyReported.add(name);
            });
    }, [steps, initialized, skippedStepNames, sendGTMAction, updateIntercomOnboardingStep]);

    return null;
};

export default SetupGuideStepDoneActionListener;
